import { api } from 'src/api';
import { dataLayerPush } from 'src/helpers/gtm';
import type { postStatsBrokenImageRequest } from '@lt/api/dist/methods/stats/types';

export const pushShowImageAnalytics = (id, time) => {
  // считает секунды, сколько пользователь смотреть конкретное изображение
  const seconds = time / 1000;

  dataLayerPush({
    event: 'hotel_gallery',
    type: 'show',
    image_id: id,
    timeShow: seconds,
  });
};

export const pushCloseGalleryAnalytics = (id) => {
  dataLayerPush({
    event: 'hotel_gallery',
    type: 'close',
    image_id: id,
  });
};

export const pushOpenGalleryAnalytics = (id) => {
  dataLayerPush({
    event: 'hotel_gallery',
    type: 'open',
    image_id: id,
  });
};

export const pushPlayGalleryVideoAnalytics = (
  hotel_id: number,
  hotel_name: string,
) => {
  dataLayerPush({
    event: 'video_played',
    custom_params: {
      hotel_id,
      hotel_name,
    },
  });
};

export const pushStatsBrokenImage = async (
  data: postStatsBrokenImageRequest,
) => {
  try {
    await api.postStatsBrokenImage(data);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
};
